import { GTM } from '../../../../../helpers'
import nrLogger from '../../../../../helpers/nrLogger'
import formatInventories from '../../../components/Summary/ProceedToCheckout/Regular/formatInventories'
import formatItems from '../../../components/Summary/ProceedToCheckout/Regular/formatItems'
import formatItemsGroundDeliveryTime from '../../../components/Summary/ProceedToCheckout/Regular/formatItemsGroundDeliveryTime'

const executeGTM = (oItems, skuArray, isWmoEnabled) => {
  try {
    const orderItems = formatItems(oItems)
    
    const {
      removeFromCart,
      removeFromCartCMS,
      getProductFromCartItemData,
    } = GTM

    const inventories = formatInventories(oItems)
    const itemsGroundDeliveryTime = formatItemsGroundDeliveryTime(oItems)
    const products = orderItems.map(orderItem => {
      const isFromProductOption = skuArray.includes(orderItem.skuNumber)
      return getProductFromCartItemData(
        {
          ...orderItem,
          inventory: inventories[orderItem.productId] || {},
          isFromProductOption,
          groundDeliveryTime: itemsGroundDeliveryTime[orderItem.productId] || '',
        },
        orderItem.quantity,
      )
    })
  
    if (isWmoEnabled) {
      removeFromCartCMS({ oItems })
    }
    removeFromCart({ products })
    
  } catch (error) {
    nrLogger.error('ShoppingCartV2.useRemoveItemsCallback.executeGTM.error', error)
  }
}

export default executeGTM
